import { defineType } from "sanity";

export default defineType({
  name: "confirmedShorex",
  title: "Confirmed Shore Excursion",
  type: "object",
  preview: {
    select: {
      name: "shorex.name",
      includedInAllInclusive: "includedInAllInclusive"
    },
    prepare({ name, includedInAllInclusive }) {
      return {
        title: `${name} (${includedInAllInclusive ? "Included" : "Selected"})`
      };
    }
  },
  fields: [
    {
      title: "Shorex WebCode",
      description: "The web code of the shorex definition under the port.",
      name: "shorexWebCode",
      type: "string",
      readOnly: true
    },
    {
      title: "Shorex",
      name: "shorex",
      type: "reference",
      to: [{ type: "shorex" }],
      readOnly: true,
      weak: true
    },
    {
      name: "includedInAllInclusive",
      title: "Included in All Inclusive?",
      type: "boolean",
      readOnly: true
    },
    {
      name: "fareCodes",
      title: "Fare Codes",
      type: "array",
      of: [{ type: "string" }],
      readOnly: true
    },
    {
      name: "duration",
      title: "Duration",
      type: "number",
      readOnly: true
    },
    {
      name: "price",
      description: "Price in USD",
      title: "Price",
      type: "number",
      readOnly: true
    },
    {
      name: "originalPrice",
      description: "Original price in USD",
      title: "Original Price",
      type: "number",
      readOnly: true
    }
  ]
});
